module.exports = __webpack_public_path__ + "media/images/room_menu_icon/machine_ports-8b8cfa588a86cd92704a6f658946fa57.png";